import apiClient, { type PagedResponse } from '../../client'
import type {
  ComponentTierItem,
  CreateComponentTierRequest,
  UpdateComponentTierRequest,
  GetComponentTiersParams,
} from '../../models/maestros.models'

const BASE_PATH = '/maestros/component-tiers'

export const componentTiersService = {
  async getAll(params?: GetComponentTiersParams): Promise<PagedResponse<ComponentTierItem>> {
    return apiClient.get<PagedResponse<ComponentTierItem>>(BASE_PATH, params)
  },
  async getById(id: string): Promise<ComponentTierItem> {
    return apiClient.get<ComponentTierItem>(`${BASE_PATH}/${id}`)
  },
  async create(data: CreateComponentTierRequest): Promise<ComponentTierItem> {
    return apiClient.post<ComponentTierItem, CreateComponentTierRequest>(BASE_PATH, data)
  },
  async update(id: string, data: UpdateComponentTierRequest): Promise<ComponentTierItem> {
    return apiClient.put<ComponentTierItem, UpdateComponentTierRequest>(`${BASE_PATH}/${id}`, data)
  },
  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },
}
